"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tbl = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lib_1 = require("../../lib");
const TblHead_1 = require("./TblHead");
const TblBody_1 = require("./TblBody");
const TblBodyCell_1 = require("./TblBodyCell");
const TblHeadCell_1 = require("./TblHeadCell");
const TblRow_1 = require("./TblRow");
const TblComponent = (_a) => {
    var { children, className } = _a, rest = (0, tslib_1.__rest)(_a, ["children", "className"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, rest, { className: (0, lib_1.classnames)('tbl', className) }, { children: children }), void 0));
};
class Tbl extends react_1.Component {
    render() {
        return (0, jsx_runtime_1.jsx)(TblComponent, Object.assign({}, this.props), void 0);
    }
}
exports.Tbl = Tbl;
Tbl.Head = TblHead_1.TblHead;
Tbl.Body = TblBody_1.TblBody;
Tbl.Cell = TblBodyCell_1.TblBodyCell;
Tbl.HeadCell = TblHeadCell_1.TblHeadCell;
Tbl.Row = TblRow_1.TblRow;
//# sourceMappingURL=Tbl.js.map